module.exports = __webpack_public_path__ + "img/all-selected.bc2bae93.svg";